import React from 'react';
import { Alert, Col, Input, InputNumber, Row, Typography } from 'antd';
import { PercentageOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import buildNamePath from '~/utils/buildNamePath';
import { capitalizeWords } from '~/utils/validateCharacters';
import Form from '../Form';
import Checkbox from '../inputs/Checkbox';
import DropDown from '../inputs/DropDown';
import InfoWidget from '../inputs/InfoWidget';
import Hint from '../Hint';
import CustomTooltip from '../OpenedToolTip';

function ComponentSelector(props: any) {
  const { item, sectionHeader, parentKey, formName, index, selectedProducts, productLocked } = props;
  const n = buildNamePath(formName);
  const { t } = useTranslation();
  const isLocked = !!productLocked;

  // Parser to allow only numbers and up to two decimal points
  const parseValueTo2Digit = (value: string | undefined): string => {
    if (!value) {
      return '';
    }
    if (value?.includes('.')) {
      return value;
    }

    const dividedNumber = value?.length > 1 ? 10 ** (value?.length - 2) : 1;
    const parseWith2Digits = (Number(value) / dividedNumber).toString();
    return parseWith2Digits.substr(0, 5);
  };

  switch (item?.type) {
    case 'select':
      return (
        <Row gutter={6}>
          <Col span={12}>
            {sectionHeader === 'CONFIGURATION' && item?.name && (
              <Typography.Title level={5}>{capitalizeWords(t(item.name))}</Typography.Title>
            )}
            <Form.Item
              disabled={isLocked}
              rules={[{ required: true }]}
              key={`${parentKey}-${sectionHeader}-${index}-${formName}-FormItem`}
              name={n(['products', index, item?.key])}
            >
              <DropDown
                key={`${parentKey}-${sectionHeader}-${index}-${formName}-dropDown`}
                dropDownKey={item?.dropDownKey}
                itemKey={`${parentKey}-${sectionHeader}-${index}-${formName}-dropDown`}
                parentKey={parentKey}
                selectedProducts={selectedProducts}
                disabled={isLocked}
              />
            </Form.Item>
          </Col>
          {/* <Col span={3}>
            <CustomTooltip
              text={
                parentKey === 'DIGITAL_TRAVEL_PAYMENT'
                  ? t('Please choose Annual')
                  : t('Please choose one option from Annual and Monthly.')
              }
              width={parentKey === 'DIGITAL_TRAVEL_PAYMENT' ? 180 : 300}
            />
          </Col> */}
        </Row>
      );

    case 'text':
      return (
        <>
          <Row>
            <Col span={12}>
              <Form.Item
                initialValue={0}
                disabled
                rules={[
                  { required: true },
                  {
                    message: 'The value should be equal or below 30%',
                    validator: (_, value) => {
                      if (value > 30) {
                        return Promise.reject();
                      }
                      return Promise.resolve();
                    },
                  },
                  {
                    message: 'Value must be greater than or equal to 0',
                    validator: (_, value) => {
                      if (!/^[+]?\d+([.]\d+)?$/.test(value)) {
                        return Promise.reject();
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
                key={`${parentKey}-${sectionHeader}-${index}-${formName}-FormItem`}
                name={n(['products', index, item?.key])}
              >
                <InputNumber
                  style={{ width: '100%' }}
                  step={0.01}
                  parser={parseValueTo2Digit}
                  addonAfter={<PercentageOutlined style={{ fontSize: '12px' }} />}
                  key={`${parentKey}-${sectionHeader}-${index}-${formName}`}
                  type="number"
                />
              </Form.Item>
            </Col>
            {/* <Col span={3}>
              <CustomTooltip text={t('Value must be greater than or equal to 0 and below 30%')} width={300} />
            </Col> */}
          </Row>
        </>
      );
    case 'info':
      return (
        <InfoWidget
          key={`${parentKey}-${sectionHeader}-${index}-${formName}-InfoWidget`}
          itemKey={`${parentKey}-${sectionHeader}-${index}-${formName}-InfoWidget`}
          item={item}
        />
      );

    default:
      <></>;
  }
  return <></>;
}
export default ComponentSelector;
